import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    data: [],
    page: {
        page: 1,
        size: 10,
        totalPage: 1,
        totalSize: 1,
    }
};

const partnerManagerSlice = createSlice({
    name: 'partnerManager',
    initialState,
    reducers: {
        funGetPartnerManager(state, action){
            const { list, page, size, totalPage, totalSize } = action.payload;
            state.data = list.map(( partnerManager ) => {
                return{
                    ...partnerManager,
                }
            });
            state.page = { page, size, totalPage, totalSize };
        }
    },
});

export const partnerManagerActions = partnerManagerSlice.actions;
export default partnerManagerSlice.reducer;